import AppCardSidebarOrderLayout from './AppCardSidebarOrderLayout.vue';

export default AppCardSidebarOrderLayout;



// WEBPACK FOOTER //
// ./src/uikit/layouts/cardlayouts/CardSidebarOrderLayout/index.ts